module.exports = __webpack_public_path__ + "img/launch-marketing-campaigns.3bbfcf0e.png";